import { resolveApiBase } from './utils/apiBaseOverride';

// The host app (offline engine) may point this POS at its on-device loopback server; any other value is ignored (see utils/apiBaseOverride.js).
const defaultApiBase =
  process.env.NODE_ENV === "development"
    ? "https://posstageapi.orderart.com.au"
    : "https://posstageapi.orderart.com.au";

export const defaultConfig = {
  baseAPIUrl: resolveApiBase(defaultApiBase, typeof window !== 'undefined' ? window : null),
};

 export const ERROR_RECOVERY_CONFIG = {
  redirectOnError: true,
  redirectPath: '/dashboard',
  showToast: true,
  toastMessage: 'Something went wrong. Redirecting to dashboard...',
  preventLoop: true
};
